import ReactDOM from "react-dom";
import generalStyles from "./generalStyles";

Math.easeInOutQuad = function(t, b, c, d) {
    t /= d / 2;
    if (t < 1) return c / 2 * t * t + b;
    t--;
    return -c / 2 * (t * (t - 2) - 1) + b;
};

export function scrollTo(to, duration) {
    let element = document.scrollingElement
        ? document.scrollingElement
        : document.body;
    var start = element.scrollTop,
        change = to - start,
        currentTime = 0,
        increment = 20;

    var animateScroll = function() {
        currentTime += increment;
        var val = Math.easeInOutQuad(currentTime, start, change, duration);
        element.scrollTop = val;
        if (currentTime < duration) {
            setTimeout(animateScroll, increment);
        }
    };
    animateScroll();
}

export function getVideoId(url) {
    let youtubeID = url.match(
        /(?:https?:\/{2})?(?:w{3}\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\?v=|\/)([^\s&]+)/
    );
    return youtubeID && youtubeID[1] ? youtubeID[1] : "";
}

export function getVideoPreviewImg(url) {
    let image;

    let youtubeID = getVideoId(url);

    if (youtubeID) {
        image = "https://img.youtube.com/vi/" + youtubeID + "/hqdefault.jpg";
    }

    return image;
}

export function fadeInTransition(ref) {
    var elem = ReactDOM.findDOMNode(ref);
    elem.style.opacity = 0;
    if (typeof window !== `undefined`) {
        window.requestAnimationFrame(function() {
            elem.style.transition = generalStyles.transition;
            elem.style.transitionDuration = ".8s";
            elem.style.opacity = 1;
        });
    }
}



// WEBPACK FOOTER //
// ./src/utils/functions.js